import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/shift"

export const addShift = async data => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const getHaveOpenShift = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/have/open?${query}`)

  return response.data
}

export const getShifts = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const closeShift = async (shiftId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/close/${shiftId}`, data)

  return response.data
}

export const shiftCashManagement = async (shiftId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/cash/management/${shiftId}`, data)

  return response.data
}